var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner " }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "line" }, [
            _vm._v("\n                专业级技术咨询和系统服务\n            "),
          ]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "desc" }, [
          _vm._v(
            "\n            大数据与人工智能技术、为企业打造安全、便捷、高效的一站式专业技术服务平台\n        "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }